import { DragDropActionTypes } from "./constants";
import { createLayoutKeyObject, createLayoutObject } from "./layout";

export const createCreateLayoutKey =
  (username: string) => (layoutId: any, layoutKey: any) => ({
    type: DragDropActionTypes.CREATE_POS_LAYOUT_KEY,
    payload: {
      layoutId,
      layoutKey: createLayoutKeyObject(layoutKey),
    },
    meta: { posLayout: { username } },
  });

export const createMoveKey =
  (username: string) => (layoutId: any, keyId: any, position: any) => ({
    type: DragDropActionTypes.MOVE_POS_LAYOUT_KEY,
    payload: { layoutId, keyId, position },
    meta: { posLayout: { username } },
  });

export const createDeleteKey =
  (username: string) => (layoutId: any, keyId: any) => ({
    type: DragDropActionTypes.DELETE_POS_LAYOUT_KEY,
    payload: { layoutId, keyId },
    meta: { posLayout: { username } },
  });

export const createUpdateLayoutKey =
  (username: string) => (layoutId: any, keyId: any, data: any) => ({
    type: DragDropActionTypes.UPDATE_POS_LAYOUT_KEY,
    payload: {
      layoutId,
      keyId,
      data,
    },
    meta: { posLayout: { username } },
  });

export const createCreateLayout = (username: string) => (layout: any) => ({
  type: DragDropActionTypes.CREATE_POS_LAYOUT,
  payload: {
    layout: createLayoutObject(layout),
  },
  meta: { posLayout: { username } },
});

export const createUpdateLayout =
  (username: string) => (layoutId: any, data: any) => ({
    type: DragDropActionTypes.UPDATE_POS_LAYOUT,
    payload: {
      layoutId,
      data,
    },
    meta: { posLayout: { username } },
  });

export const createDeleteLayout = (username: string) => (layoutId: any) => ({
  type: DragDropActionTypes.DELETE_POS_LAYOUT,
  payload: {
    layoutId,
  },
  meta: { posLayout: { username } },
});
